import { render } from "./PickerItems.html?vue&type=template&id=388e3e78&scoped=true&ts=true"
import script from "./PickerItems.ts?vue&type=script&lang=ts"
export * from "./PickerItems.ts?vue&type=script&lang=ts"

import "./PickerItems.scss?vue&type=style&index=0&id=388e3e78&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388e3e78"]])

export default __exports__